//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  layout: 'marketing-page',
  head() {
    return {
      title: 'Bill of Materials (BOM) Management Software | BOMIST',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'Manage your Bills of Materials with ease. BOMIST lets you create, edit and version BOMs, check real-time part availability and pricing, and sync with your inventory — all in one place.'
        }
      ]
    };
  }
};
